export default __webpack_public_path__ + "static/media/ai-icon1.52bd04c5.png";